import React from "react"
import { useSelector } from "react-redux"
import { Card, CardContent, Typography, makeStyles, useTheme } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { Chart } from "react-google-charts"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: "376px",
	},
	cardBody: {
		padding: 0,
		"&:last-child": {
			paddingBottom: 0,
		},
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: 600,
		padding: "4px 20px",
	},
	skeletonWrapper: {
		padding: 15,
	},
	NoData: {
		minHeight: 300,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
}))

const EmailReceiver = ({ selectedReceiver = [], data = [], defaultData = [], isLoading = false }) => {
	const classes = useStyles()
	const theme = useTheme()
	const [t] = useTranslation("global")

	const options = {
		title: "",
		height: 300,
		animation: {
			startup: true,
			duration: 1000,
			easing: "inAndOut",
		},
		colors: [theme.palette.dashboard.D10, theme.palette.dashboard.D20],
		chartArea: { left: 150, right: 40, top: 20, bottom: 30, width: "100%" },
		bar: {
			groupWidth: `${
				(25 * ((selectedReceiver ? data?.[selectedReceiver?.[0]]?.slice(0, 10)?.length : defaultData?.length) - 1)) / 8
			}%`,
		},
		hAxis: { gridlines: { color: "none", minSpacing: 300 }, baselineColor: "none", textPosition: "none" },
		isStacked: true,
		legend: {
			position: "bottom",
			alignment: "end",
			labels: {
				boxWidth: 10,
				usePointStyle: true,
			},
		},
	}
	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardBody}>
				<Typography variant="subtitle1" className={classes.title}>
					{t("dashboard.emailReceiver")}
				</Typography>
				{isLoading ? (
					<div className={classes.skeletonWrapper}>
						<Skeleton variant="rect" width={"100%"} height={300} />
					</div>
				) : (selectedReceiver && Object.keys(data)?.length) || (!selectedReceiver && defaultData?.length) ? (
					<Chart
						chartType="BarChart"
						data={selectedReceiver ? data?.[selectedReceiver?.[0]]?.slice(0, 10) : defaultData}
						options={options}
					/>
				) : (
					<Typography variant="subtitle1" className={classes.NoData}>
						{t("dashboard.noDataFound")}
					</Typography>
				)}
			</CardContent>
		</Card>
	)
}

export default EmailReceiver
